<template>
    <div>
        <Header title="企微配置">
            <template v-slot:content>
                <div style="display: flex">
                    <div style="flex:1">
                    </div>
                </div>
            </template>
        </Header>
        <Form  :model="submitForm" :label-width="140">
            <div class="my-white-mod">
                <Divider  orientation="left">企业微信基础配置</Divider>
                <FormItem label="企业ID">
                    <Row>
                        <Col span="7">
                            <Input type="text"  v-model="submitForm.corp_id" placeholder="请输入企业ID"></Input>
                        </Col>
                        <Col span="3" >
                            <Tooltip  max-width="300" content="企业微信ID，前往企业微信后台【我的企业】企业信息中可查看"  placement="top" >
                                <Icon type="md-help-circle" size="20" />
                            </Tooltip>
                        </Col>
                    </Row>
                </FormItem>
            </div>
            <div class="my-white-mod">
                <Divider  orientation="left">企业微信自建应用设置</Divider>
                <FormItem label="应用AgentId">
                    <Row>
                        <Col span="7">
                            <Input type="text"   v-model="submitForm.agent_id" placeholder="请输入自建应用的agentId"></Input>
                        </Col>
                        <Col span="3" >
                            <Tooltip  max-width="300" content="企业微信自建应用AgentId，可前往【应用管理】进行自建应用"  placement="top" >
                                <Icon type="md-help-circle" size="20" />
                            </Tooltip>
                        </Col>
                    </Row>
                </FormItem>
                <FormItem label="应用Secret">
                    <Row>
                        <Col span="7">
                            <Input type="text"  v-model="submitForm.secret"  placeholder="请输入自建应用的secret"></Input>
                        </Col>
                        <Col span="3" >
                            <Tooltip  max-width="300" content="企业微信自建应用secret，可前往【应用管理】自建应用应用内查看secret"  placement="top" >
                                <Icon type="md-help-circle" size="20" />
                            </Tooltip>
                        </Col>
                    </Row>
                </FormItem>
            </div>

            <div class="my-white-mod">
                <Divider  orientation="left">企业微信通讯录配置</Divider>
                <FormItem label="Token">
                    <Row>
                        <Col span="7">
                            <Input type="text"  v-model="submitForm.token"   placeholder="请输入企业微信通讯录事件接收服务器token"></Input>
                        </Col>
                        <Col span="3" >
                            <Tooltip  max-width="300" content="请输入通讯录事件接收服务器token"  placement="top" >
                                <Icon type="md-help-circle" size="20" />
                            </Tooltip>
                        </Col>
                    </Row>
                </FormItem>
                <FormItem label="EncodingAESKey">
                    <Row>
                        <Col span="7">
                            <Input type="text" v-model="submitForm.EncodingAESKey"  placeholder="请输入企业微信通讯录EncodingAESKey"></Input>
                        </Col>
                        <Col span="3" >
                            <Tooltip  max-width="300" content="企业微信通讯录EncodingAESKey"  placement="top" >
                                <Icon type="md-help-circle" size="20" />
                            </Tooltip>
                        </Col>
                    </Row>
                </FormItem>
                <FormItem label="服务器地址">
                    <Row>
                        <Col span="7">
                            <Input id="server_url"  v-model="plat_call_back_url"  disabled type="text" ></Input>
                        </Col>
                        <Col span="2" >
                            <Button type="success" @click="copy">复制</Button>
                        </Col>
                    </Row>
                </FormItem>
            </div>
            <div class="my-white-mod" style="text-align:center;padding:30px">
                <Button type="primary" @click="submitApp">保存</Button>
            </div>
        </Form>

    </div>

</template>
<script>
    import {save_conf, get_conf} from "@/api/system";
    import {copyText} from "@/utils/helper";
    import {Header} from "@/components/mainLayout"
    export default {
        components:{
            Header
        },
        data(){
            return{
                submitForm:{
                    corp_id:"",
                    agent_id:"",
                    secret:"",
                    EncodingAESKey:"",
                    token:""
                },
                plat_call_back_url : ""
            }
        },
        mounted(){
            let userInfo = this.$store.state.userInfo;
            this.plat_call_back_url = `http://crm.api.hulianzaowu.top/admin/call/index/${userInfo.platform_id}`
            this.getConf()
        },
        methods:{
            copy(){
                copyText(this.plat_call_back_url);
            },
            submitApp(){
                if (this.submitForm.corp_id == "") {
                    this.$Message.error("请输入企业ID");return
                }
                if (this.submitForm.agent_id == "") {
                    this.$Message.error("请输入自建应用的agentId");return
                }
                if (this.submitForm.secret == "") {
                    this.$Message.error("请输入自建应用的secret");return
                }
                if (this.submitForm.token == "") {
                    this.$Message.error("请输入企业微信通讯录事件接收服务器token");return
                }
                if (this.submitForm.EncodingAESKey == "") {
                    this.$Message.error("请输入企业微信通讯录EncodingAESKey");return
                }
                save_conf(this.submitForm).then(res=>{
                    if (res.code == 200) {
                        this.$Message.success(res.msg)
                    } else {
                        this.$Message.error(res.msg)
                    }
                })
            },
            getConf(){
                get_conf().then(res=>{
                    if (res.code == 200) {
                        this.submitForm = res.data
                    }
                })
            }
        }
    }
</script>
<style scoped>
    >>>.ivu-input{
        width:400px!important;
    }
    >>>.ivu-icon{
        cursor: pointer;
    }
</style>
